export const transformContractToApplication = (data) => fetch(`/changecustomer/openNewApplication`, {
    method: "post",
    body: JSON.stringify(data),
    headers: {
        "content-type": "application/json"
    }
}).then(res => {
    if (res.ok)
        return res.json();
    return res.json();
});
//# sourceMappingURL=TransformContractToApplication.js.map